

/**
 * Truncates a sentence to a specified number of words and adds ellipses if necessary.
 *
 * @param {string} sentence - The sentence to truncate.
 * @param {number} wordLimit - The number of words to keep before truncating.
 * @returns {string} - The truncated sentence with ellipses if applicable.
 */
export function truncateSentence(sentence, wordLimit = 3) {
  if (!sentence || typeof sentence !== "string") {
    return "";
  }

  const words = sentence.trim().split(/\s+/); // Split by whitespace
  if (words.length <= wordLimit) {
    return sentence; // Return the original sentence if it has `wordLimit` or fewer words
  }

  return `${words.slice(0, wordLimit).join(" ")}...`;
}
